module.exports = __webpack_public_path__ + "img/45.9623577a.jpg";